import {Maybe} from '../graphql/generated/types';
import {LocaleType} from '../locale/type';
import {compareVersion} from './compareVersion';
import {
  ANDROID_ONEBUILD_WEBVIEW_BUILD_NUMBER,
  IOS_ONEBUILD_WEBVIEW_BUILD_VERSION,
} from './constant';
import {requestContext} from './requestContext';

export function getDocumentTitle(
  _title: Maybe<string | undefined>,
  lang: LocaleType = 'ko'
): string {
  let title = _title;
  if (!title) {
    return '';
  }

  const {isWebView, appVersion, isAndroid, isIos} =
    requestContext?.requestInfo?.display || {};

  const webviewTitlePrefix1 = lang === 'ko' ? '카카오페이지,' : 'Kakaopage,';
  const webviewTitlePrefix2 = '페이지 스토어,';

  if (title.startsWith(webviewTitlePrefix2)) {
    title = title.replace(webviewTitlePrefix2, '');
  } else if (title.startsWith(webviewTitlePrefix1)) {
    title = title.replace(webviewTitlePrefix1, '');
  }
  title = title.trim();

  if (isWebView) {
    if (
      (isAndroid &&
        compareVersion({
          buildVersion: {
            lowerBuildNumber: appVersion?.androidBuildNumber,
            higherBuildNumber: ANDROID_ONEBUILD_WEBVIEW_BUILD_NUMBER,
          },
        })) ||
      (isIos &&
        compareVersion({
          appVersion: {
            lowerBuildVersion: appVersion?.iosBuildVersion,
            higherBuildVersion: IOS_ONEBUILD_WEBVIEW_BUILD_VERSION,
          },
        }))
    ) {
      // 원빌드 이전 버전에서는 "페이지 스토어," 를 앞에 붙여줍니다. 기존이 굉장히 이상했던 스펙인데 웹뷰에서 "페이지 스토어," 가 있을때만 타이틀을 노출하고 있었습니다. 원빌드에선 굳이 해당 스펙이 필요 없다고 하여 버전으로 분기합니다.
      return `${webviewTitlePrefix2} ${title}`;
    }
    return title;
  } else {
    return `${title} | ${webviewTitlePrefix1.replace(',', '')}`;
  }
}
